import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import Privacy from "./views/Privacy.vue";
import Store from "./views/Store.vue";
import Oauth from "./views/Oauth.vue";
import Confirm from "./views/Confirm.vue";
import ResetPassword from "./views/ResetPassword.vue";
import RegisterInvited from "./views/RegisterInvited.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/privacy/:lang",
      name: "privacy",
      component: Privacy
    },
    {
      path: "/store",
      name: "store",
      component: Store
    },
    {
      path: "/confirm/:token",
      name: "confirm",
      component: Confirm
    },
    {
      path: "/resetPassword/:token",
      name: "resetPassword",
      component: ResetPassword
    },
    {
      path: "/registerInvited/:token",
      name: "registerInvited",
      component: RegisterInvited
    },
    {
      path: "/oauth",
      name: "oauth",
      component: Oauth
    },
    {
      path: "*",
      redirect: { name: "home" }
    }
  ]
});
